import { useLocale } from '../../i18n/react';
import { appHref } from '../../routing/browser';
import { renderInformationPage } from './render';
import type { InformationPageName } from './content';
import './information.css';

export function InformationPage({ page }: { page: InformationPageName }) {
  const locale = useLocale();
  const basePath = appHref('').replace(/\/$/, '');
  return <div dangerouslySetInnerHTML={{ __html: renderInformationPage(page, locale, basePath) }} />;
}
